import React, { useMemo } from "react";
import KanbanBoard from "../../components/common/KanbanBoard";
import T from '../../components/common/T';
import { BriefcaseIcon } from "@heroicons/react/24/outline";

const WorkforceKanbanView = ({ workforce, onAllocateClick }) => {

  const COLUMNS = [
    { id: "Available", title: "Available / Bench", dotColor: "bg-emerald-500" },
    { id: "Assigned", title: "Allocated to Projects", dotColor: "bg-blue-500" },
    { id: "On Leave", title: "On Leave / Unavailable", dotColor: "bg-amber-500" },
  ];

  // 🟢 THE FIX: We map your complex DB statuses into the 3 simple Kanban columns
  const mappedWorkforce = useMemo(() => {
    return (workforce || []).map(person => {
      let kanban_status = "Available";
      
      if (person.status === 'On Leave') {
         kanban_status = "On Leave";
      } else if (['Partially Assigned', 'Fully Booked'].includes(person.calculated_status)) {
         kanban_status = "Assigned";
      }
      
      return { ...person, kanban_status };
    });
  }, [workforce]);

  const handleDragEnd = (result) => {
    const { destination, draggableId } = result;
    if (!destination) return;
    
    if (destination.droppableId === "Assigned") {
      const person = mappedWorkforce.find(w => String(w.id) === String(draggableId));
      if (person && onAllocateClick) onAllocateClick(person);
    } else {
      console.log(`Moved ${draggableId} to ${destination.droppableId}`);
    }
  };

  const renderCard = (person) => (
    <div className="bg-white dark:bg-[#161b22] p-4 rounded-xl shadow-xs border border-gray-200 dark:border-[#30363d] hover:shadow-md dark:hover:border-slate-600 transition cursor-grab active:cursor-grabbing flex flex-col min-h-[130px]">
      <div className="flex justify-between items-start gap-2">
        <div className="overflow-hidden">
          <h4 className="font-bold text-gray-900 dark:text-white text-base leading-tight truncate">{person.name}</h4>
          <p className="text-[11px] text-gray-500 dark:text-slate-400 font-mono mt-1">{person.employee_id}</p>
        </div>
        <span className="text-[10px] bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-slate-300 px-2 py-1 rounded font-bold uppercase tracking-wider border border-gray-200 dark:border-slate-700 shrink-0">
          {person.role}
        </span>
      </div>

      <div className="mt-auto pt-3 border-t border-gray-100 dark:border-[#30363d]">
        <span className="block text-[10px] text-gray-400 dark:text-slate-500 font-bold uppercase tracking-wider mb-1">Active Allocations</span>
        <div className="flex flex-wrap gap-1">
          {person.allocations && person.allocations.length > 0 ? (
            person.allocations.map(alloc => (
              <span key={alloc.id} className="text-[10px] bg-blue-50 dark:bg-blue-950/40 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800/60 px-1.5 py-0.5 rounded font-medium">
                {alloc.project_name} ({alloc.allocation_percentage}%)
              </span>
            ))
          ) : (
            <span className="text-[10px] text-gray-400 dark:text-slate-500 italic"><T>No active projects</T></span>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <KanbanBoard 
      columns={COLUMNS}
      items={mappedWorkforce} // 🟢 Feed in the mapped data
      groupBy="kanban_status" // 🟢 Group by our new mapped field
      onDragEnd={handleDragEnd}
      renderCard={renderCard}
    />
  );
};

export default WorkforceKanbanView;